import { SharedStationChip } from '@app/components/stations/SharedStationChip';
import { SharedStationIcon } from '@app/components/stations/SharedStationIcon';
import { YoutubeNativeStationChip } from '@app/components/stations/YoutubeNativeStationChip';
import { YoutubeNativeStationIcon } from '@app/components/stations/YoutubeNativeStationIcon';
import { MinimumStation, Station } from '@mi-front/core';
import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export type StationIndicatorsVariant = 'icon' | 'chip';
type StationIndicatorsSize = 'small' | 'medium';

interface StationIndicatorsProps {
  station: Station | MinimumStation;
  variant?: StationIndicatorsVariant;
  size?: StationIndicatorsSize;
  sx?: SxProps<Theme>;
}

/**
 * Groups station indicators so callers can render shared and YouTube-native flags consistently.
 */
export function StationIndicators({
  station,
  variant = 'icon',
  size = 'medium',
  sx,
}: StationIndicatorsProps) {
  if (variant === 'chip') {
    return (
      <Box display="inline-flex" alignItems="center" gap={0.5} sx={sx}>
        <SharedStationChip station={station} />
        <YoutubeNativeStationChip station={station} />
      </Box>
    );
  }

  return (
    <Box display="inline-flex" alignItems="center" gap={0.5} sx={sx}>
      <SharedStationIcon station={station} size={size} />
      <YoutubeNativeStationIcon station={station} size={size} />
    </Box>
  );
}
